import { EnvironmentInjector, inject, Injectable, runInInjectionContext } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { Auth, authState, signOut as fireSignOut, sendEmailVerification as fireSendEmailVerification, createUserWithEmailAndPassword, getAdditionalUserInfo, GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup, verifyPasswordResetCode, sendPasswordResetEmail, signInWithCustomToken, EmailAuthProvider, reauthenticateWithCredential, updatePassword } from '@angular/fire/auth';
import { doc, docSnapshots, DocumentData, DocumentReference, Firestore, setDoc } from '@angular/fire/firestore';

import { User } from '../../../globals/store/user.data';
import { lastValueFrom, Observable, of, Subject } from 'rxjs';
import { EventStreamChange } from '../models/$event.model';
import { ErrorStreamChange } from '../models/$error.model';
import { switchMap, take } from 'rxjs/operators';
import {  } from 'rxjs';
import {UiService} from "./ui.service";
import { LogService } from './log.service';
import { Store } from '@ngrx/store';
import { uiActions } from '../store/ui.era';
import { userActions } from '../store/user.era';
import { HttpClient } from '@angular/common/http';

declare var grecaptcha: any;
@Injectable({ providedIn: 'root'})
export class AuthService {

    // public user: Observable<User>;
    public uid;
    readonly _file:string = "";
    readonly api = `${environment.functionsURL}`;
    is_create_user = false; // for temporary auth, used when creating a user, and routing definition
    creating_user = false;
    just_created_user = false;
    signing_in = false;
    password_email_reset_error: string;
    password_email_reset = false;
    password_email_reset_loading = false;
    temp_user_object: User;

    public SIGNED_OUT = 'signout';
    public SIGNED_IN = 'signin';
    public USER_UPDATED = 'updated';
    public auth$

    public readonly authState$: Observable<any>;
    readonly currentUserData$: Observable<any | null>; 
    public $destroy: Subject<boolean> = new Subject();
    public $events: Subject<EventStreamChange> = new Subject();
    public $errors: Subject<ErrorStreamChange> = new Subject();
    private db = inject(Firestore);
    envInjector = inject(EnvironmentInjector)
    // public user_from_db$: Subject<User> = new Subject();

    // accessToken;

    constructor(private router: Router,
      public store: Store, private auth: Auth,
      private ui:UiService, private log: LogService
    ) {


    this.authState$ = authState(this.auth);
    this.currentUserData$ = this.authState$.pipe(
        switchMap( user => {
            if (user) {
              this.uid = this.log.current_uid = user.uid;
              // return this.afs.doc<User>(`users/${user.uid}`)['valueChanges']();
            //const userRef = runInInjectionContext(this.envInjector, () => doc(this.db, `users/${user.uid}`) as DocumentReference<DocumentData>);
            // const doc = await userRef.get();
            // console.log('doc ', doc)
            return runInInjectionContext(this.envInjector, () => docSnapshots(doc(this.db, `users/${user.uid}`))).pipe(
              switchMap(snapshot=>{
                const currentUser = this.auth.currentUser
                if (currentUser && currentUser.providerData[0].providerId !== 'password') {
                  this.store.dispatch(userActions.setFromOAuth())
                }
                if(snapshot.exists && !snapshot.metadata.fromCache){
                  return of(snapshot.data())
                }else{
                  return of(null)
                }
              })
                // todo: figure out a more clever way of doing this ,takeUntil(this.userService.loggedOut$)
              );
            } else {
              return of(null);
            }
        })
      );
    }

    reloadUser(){
      this.auth.currentUser?.reload();
    }

    googleLogin() { // "is_new" cannot be trusted as a user can click on sign in or sign up whether or not they have an account with Joi.  Instead, use credential.additionalUserInfo.isNewUser below
        const provider = new GoogleAuthProvider();
        // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
        return this.oAuthLogin(provider);
    }

    private oAuthLogin(provider) {
        return signInWithPopup(this.auth, provider)
            .then(credential => {
                const user: any = credential.user;
                const { isNewUser, profile } = getAdditionalUserInfo(credential)
                const hasCredentials = credential && profile
                if (hasCredentials && isNewUser) {
                  user.firstName = profile['given_name'];
                  user.lastName = profile['family_name'];
                  user.emailVerified = true;
                  if (isNewUser) {
                    console.log("This is where the new user used to get sent to HS")
                      // this.log.hsSignUpForm(user);
                  }
                  this.updateUserData(user).then(_=>{ // this overwrites the user data if the user is not new, so must be moved into the is new check above.  If they are not new, the data will be loaded automatically upon sign in
                    this.store.dispatch(userActions.modifyUser(this.temp_user_object))
                  });
                }
                if (!hasCredentials) {
                  console.log("Attempt to get user from oAuth failed!", credential)
                }
                

            });
    }

    signInWithEmailAndPassword(email, password) {
        const self = this;
        this.just_created_user = false;
        signInWithEmailAndPassword(this.auth, email, password)
            .then(user => {
                this.updateUserData(user.user)
            })
            .catch(error => {
                self.signing_in = false;
                self.$errors.next({ file: 'auth.service', function: 'signInWithEmailAndPassword', code: error.code,
                    data: error, message: error.message} as ErrorStreamChange);
            });
    }
    async createUser(email, password, user_obj = {}) {
        const self = this;
        return createUserWithEmailAndPassword(this.auth, email, password)
            .then(user => {
                const newuser = Object['assign']({}, user.user, user_obj);
                this.signing_in = false;
                this.just_created_user = true;
                console.log('New user created: ', newuser);
                return this.updateUserData(newuser).then(rtn=>{
                  this.store.dispatch(userActions.loaded(this.temp_user_object))
                  self.store.dispatch(uiActions.updateUIItem('takeover_loading',''))
                    self.creating_user = false;
                }).catch(error_from_createUserWithEmailAndPassword=>{
                  console.log({ error_from_createUserWithEmailAndPassword });
                });
            })
            .catch(function(error) {
              self.just_created_user = false;
                self.store.dispatch(uiActions.updateUIItem('takeover_loading',''))
                self.creating_user = false;
                self.$errors.next({ file: 'auth.service', function: 'createUser', code: error.code,
                    data: error, message: error.message} as ErrorStreamChange);
            });
    }

    // Sets user data to firestore on login //
    private updateUserData(user) {
        console.log('updateUserData called', { user })
        const userDoc = doc(this.db, `users/${user.uid}`);
        const modifiedUser: User = {} as User;

        modifiedUser['uid'] = user.uid;
        modifiedUser['email'] = user.email;
        if (user.firstName)     modifiedUser['firstName']   = user.firstName || '';
        if (user.lastName)      modifiedUser['lastName']    = user.lastName || '';
        if (user.displayName)   modifiedUser['displayName'] = user.displayName || '';
        if (user.photoURL)      modifiedUser['photoURL']    = user.photoURL || '';
        if (user.country)       modifiedUser['country']     = user.country || '';
        if (user.emailVerified) modifiedUser.emailVerified  = true;
        const now = new Date()
        modifiedUser.lastLogin = now
        modifiedUser.UTCOffset = now.getTimezoneOffset();
        this.temp_user_object = modifiedUser;
        console.log('modifiedUser ', modifiedUser)
        return setDoc(userDoc, modifiedUser, { merge: true });
    }

    signOut(doNotNavigate = false) {
      fireSignOut(this.auth).then(() => {
        this.$destroy.next(true);
        this.store.dispatch(userActions.logout())
        if (!doNotNavigate) {
          this.router.navigate(['/login']);
        }
      });
    }

    // Used by the http interceptor to set the auth header
    async getUserIdToken(): Promise<string> {
        return await this.auth.currentUser.getIdToken() ;
    }

    async sendVerificationEmail(){
      const user =  this.auth.currentUser
      console.log({email: user.emailVerified})
      if(!user.emailVerified){
        const sent = await fireSendEmailVerification(user, {url: environment.joi.appBase + "verified/"})
        console.log({sent})
        // this.signOut();
      }
    }

    async verityCode(code: string){
      const verified = await verifyPasswordResetCode(this.auth,code);
      return verified;
    }

    sendPasswordResetEmail(email) {
        const actionCodeSettings = {
            url: 'https://' + environment.firebase.authDomain,
            handleCodeInApp: false
        };

        const self = this;
        this.password_email_reset_loading = true;
        sendPasswordResetEmail(this.auth, email, actionCodeSettings)
            .then(function() {
                // Password reset email sent.
                console.log('A password reset email was sent')
                self.password_email_reset = true;
                self.password_email_reset_loading = false;
            })
            .catch(function(error) {
                console.error(error);
                this.log.error({file:this._file, function:'sendPasswordResetEmail',response:error,error:new Error()})
                self.password_email_reset_error = error.message;
                self.password_email_reset_loading = false;
            });
    }
    /*confirmPasswordReset(code, newPassword){
        this.afAuth.auth.confirmPasswordReset(code, newPassword)
            .then(rtn=>{
                console.log('rtn ',rtn)
            })
            .catch(function(error) {
                console.log('confirmPasswordReset error ',error)
            });
    }*/
    getAuth() {
      return this.auth;
    }

    ///// STRIPE CONNECT //////


    // Login popup window
    stripeLogin() {
      const popup = window.open(`${environment.functionsURL}/stripeRedirect`, '_blank', 'height=700,width=800');
    }
    // Signin with a custom token from
    customSignIn(token) {
      return signInWithCustomToken(this.auth,token).then(() => window.close());
    }
    async updatePassword(data) {
      const credential = EmailAuthProvider.credential(data.email, data.current_password);
      await reauthenticateWithCredential(this.auth.currentUser, credential);
      await updatePassword(this.auth.currentUser, data.password);
    }



}
